import { api, ApiEnvelope } from "../../api/client";

/** Port of ApiV2/App/Controller/UsersController.php - table AdminLoginDetails (central Admin DB). */
export interface AdminUserRow {
  UserID: number; UserName: string; ClientID: string; DeptID: number; UnitID: number;
  UserRoleID: number; Status: number; AccessType: string; AccessIPs: string; UserPassword: string;
}
export const adminUsersApi = {
  list: async (p: { ReqUserID?: string; ClientID?: string } = {}) =>
    (await api.get<ApiEnvelope<AdminUserRow[]>>("/admin/users", { params: p })).data,
  update: async (body: Record<string, unknown>) => (await api.post<ApiEnvelope>("/admin/users", body)).data,
};

/** Port of ApiV2/App/Controller/AccessRolesListController.php - table AdminUserRoles. */
export interface AccessRoleRow {
  ID: number; RoleName: string; ClientID: string; Header: string; Options: string;
  EditAccess: number; DeleteAccess: number; HeaderNames: string; SubHeaderNames: string;
}
export const accessRolesApi = {
  list: async () => (await api.get<ApiEnvelope<AccessRoleRow[]>>("/admin/access-roles-list")).data,
  get: async (AccessRoleID?: number) =>
    (await api.get<ApiEnvelope & { Data: unknown }>("/admin/access-roles", { params: { AccessRoleID } })).data,
  save: async (body: Record<string, unknown>) => (await api.post<ApiEnvelope>("/admin/access-roles", body)).data,
};
